<div class="panel-heading" style="color:#ffffff;background-color: #354D6A;" title="PROJECTS">
  <div class="page-titleheader">
    PROJECTS
  </div>
</div>
<br>
<div class="row" *ngIf="!ISSHOW"
  style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
  <div class="td-col-md-2" style="width: 20%; padding-left: 20px;" class="mobileview"></div>
  <div class="card mobileviewmain" style="width: 60%; border-style: solid;border-color: #11263f;border-width: 2px; ">
    <div class="card-header">
      <div class="panel-heading" style="color:#ffffff;background-color: #11263f;" title=" {{Action}} PROJECT">
        <div class="page-titlehead">
          {{Action}} PROJECT
        </div>
      </div>
    </div>
    <!-- <div>
      <img style="cursor: pointer; color: #fff; float: right; padding-top: 5px; padding-right: 20px;"
        title="Back to Business Summary" tabindex="0" src="../../../assets/images/GoBack.png">
    </div> -->
    <div class="card-body">
      <form class="form-horizontal">
        <div class="business-container">
          <div tabindex="0" *ngIf="Message !== ''" style="padding: 0.5%">
            <div class="alert alert-danger text-center" style="width: 100%;">{{Message}}</div>
          </div>
          <div class="row" style="padding: 0.5% !important;">
            <div tabindex="0">
              <p title="Fields marked with (*) are
              required and must be completed by Administrator."
                style="color:crimson; font-size:13px;font-style:italic;text-align:left">Fields marked with (*) are
                required and must be completed by Administrator.</p>
            </div>
          </div>
          <div>
            <div class="row col-md-12">
              <span style="font-weight: bold; text-align: left;color:#1a4884;" title="Project Info"
                aria-label="Project Info" tabindex="0">
                Project Info
              </span>
            </div>
            <br>
            <form class="form-horizontal">
              <div>
                <div>
                  <div class="form-group row">
                    <div class="col-md-4 from-control">
                      <input title="Click here" type="checkbox" style="width:17px;height:17px;margin-left: 1%;"
                        [checked]="isfuture" (change)="isfuture = !isfuture;isfuturechange()" />
                      <strong title="Don't have a Project Number?" style="font-size:14px;vertical-align:top;"
                        aria-label="Don't have a Project Number?"> Don't have a Project Number?
                      </strong>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-3 form-control-label" tabindex="0" title="Fiscal Year"
                      aria-label="Fiscal Year">Fiscal Year
                      <span class="j-color">*</span></label>
                    <div class="col-md-3">
                      <input type="text" name="Fiscal Year" tabindex="0" title="{{pfiscalyear}}"
                        aria-label="Fiscal Year" [(ngModel)]="pfiscalyear" class="form-control">

                    </div>
                  </div>
                  <div class="form-group row" *ngIf="!isfuture">
                    <label class="col-md-3 form-control-label" tabindex="0" title="Project Number"
                      aria-label="Project Number">Project #
                      <span class="j-color">*</span></label>
                    <div class="col-md-4">
                      <input type="text" name="Project Number" tabindex="0" title="{{projectnumber}}"
                        aria-label="Project Number" (blur)="getprojectamounts()" [(ngModel)]="projectnumber"
                        maxlength="6" class="form-control">
                      <div style="color:crimson; font-size:13px;" tabindex="0">
                        {{projmessage}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-3 form-control-label" tabindex="0" title="Project Name"
                      aria-label="Project Name">Project Name
                      <span class="j-color">*</span></label>
                    <div class="col-md-6">
                      <input type="text" name="Project Name" tabindex="0" title="{{projectname}}"
                        [ngClass]="!isfuture &&  amountsdisable ? 'disable':''"
                        [disabled]="!isfuture &&  amountsdisable" aria-label="Project Name" [(ngModel)]="projectname"
                        class="form-control">

                    </div>
                  </div>
                  <!-- <div class="form-group row">
                    <label class="col-md-3 form-control-label" tabindex="0" title="Project Category"
                      aria-label="Project Category">Project Category
                      <span class="j-color">*</span></label>
                    <div class="col-md-4">
                      <select id="ProjectCatType" class="form-control" style="width: 100%;" title="{{projectcattype}}"
                        aria-label="Project Type" name="ProjectCatType" [(ngModel)]="projectcattype">
                        <option value="0">Select</option>
                        <option *ngFor="let n of projectcattypes" [value]="n.ProjectCategoryName">
                          {{n.ProjectCategoryName}}</option>
                      </select>

                    </div>
                  </div> -->
                  <div class="form-group row">
                    <label class="col-md-3 form-control-label" tabindex="0" title="Project Category"
                      aria-label="Project Category">Project Category
                      <span class="j-color">*</span></label>
                    <div class="col-md-4">
                      <select id="ProjectSubCatType" class="form-control" style="width: 100%;"
                        title={{projectsubcategoriestype}} aria-label="Project Category" name="ProjectSubCatType"
                        [(ngModel)]="projectsubcategoriestype">
                        <option value="0">Select</option>
                        <option *ngFor="let n of projectsubcategoriestypes" [value]="n.ProjectSubCategoryNameTypes">
                          {{n.ProjectSubCategoryNameTypes}}</option>
                      </select>

                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-3 form-control-label" tabindex="0" title="Project Status"
                      aria-label="Project Status">Project Status
                      <span class="j-color">*</span></label>
                    <div class="col-md-4">
                      <select id="ProjectStatusType" [ngClass]="isfuture ? 'disable':''" [disabled]="isfuture"
                        class="form-control" style="width: 100%;" title="{{projectstatus}}" aria-label="Project Status"
                        name="ProjectStatusType" tabindex="0" [(ngModel)]="projectstatus">
                        <option value="0">Select</option>
                        <option *ngFor="let n of projectstatustypes" [value]="n.ProjectStatusNameTypes">
                          {{n.ProjectStatusNameTypes}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div>
              </div>
            </form>
          </div>
          <div class="row col-md-12">
            <span style="font-weight: bold; text-align: left;color:#1a4884;" title="Other"
              aria-label=" Project Amounts Info" tabindex="0">
              Project Amounts Info
            </span>
          </div>
          <form class="form-horizontal">
            <div>
              <div>
                <div class="form-group row">
                  <label class="col-md-3 form-control-label" tabindex="0" title="Project Budget Amount"
                    aria-label="Project Budget Amount">Project
                    Budget Amount
                    <span class="j-color">*</span></label>
                  <div class="col-md-6">
                    <input type="text" name="Project Budget Amount" tabindex="0" title="{{pbudgetamount}}"
                      (blur)="futurebudget()" aria-label="Project Budget Amount"
                      [ngClass]="!isfuture && amountsdisable ? 'disable':''" [disabled]="!isfuture && amountsdisable"
                      [(ngModel)]="pbudgetamount" class="form-control">

                  </div>
                </div>
                <div class="form-group row" *ngIf="!isfuture">
                  <label class="col-md-3 form-control-label" tabindex="0" title="Actuals" aria-label="Actuals">Actuals
                    <span class="j-color">*</span></label>
                  <div class="col-md-6">
                    <input type="text" name="Actuals" tabindex="0" title="{{pactuals}}" maxlength="100"
                      aria-label="Actuals" [ngClass]="amountsdisable ? 'disable':''" [disabled]="amountsdisable"
                      [(ngModel)]="pactuals" class="form-control">

                  </div>
                </div>
                <div class="form-group row" *ngIf="!isfuture">
                  <label tabindex="0" title="Amount Encumbered" aria-label="Amount Encumbered"
                    class="col-md-3 form-control-label">Amount Encumbered <span class="j-color">*</span></label>
                  <div class="col-md-6">
                    <input type="text" name="Amount Encumbered" tabindex="0" title="{{pamtencumbered}}"
                      aria-label="Amount Encumbered" [ngClass]="amountsdisable ? 'disable':''"
                      [disabled]="amountsdisable" [(ngModel)]="pamtencumbered" class="form-control">
                  </div>
                </div>

                <div class="form-group row" *ngIf="!isfuture">
                  <label tabindex="0" title="Remaining Balance" aria-label="Remaining Balance"
                    class="col-md-3 form-control-label">Remaining Balance <span class="j-color">*</span></label>
                  <div class="col-md-6">
                    <input type="text" name="Remaining Balance" tabindex="0" title="{{premainingbalance}}"
                      aria-label="Remaining Balance" [ngClass]="amountsdisable ? 'disable':''"
                      [disabled]="amountsdisable" aria-label="Remaining Balance" [(ngModel)]="premainingbalance"
                      class="form-control">
                  </div>
                </div>
              </div>
            </div>
            <div>
            </div>
          </form>

          <form>
            <div class="form-group row">
              <div class="col-md-3">
                <label tabindex="0" title="Comments" aria-label="Comment" class="form-control-label"
                  style="vertical-align: top;">
                  Comments:
                </label>
              </div>
              <div class="col-md-6">
                <textarea id="Comment" [(ngModel)]="pcomment" aria-label="Enter Comments" title="{{pcomment}}"
                  name="Comment" rows="3" cols="65" maxlength="2500"></textarea>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div>
              <div class="form-group row">
                <div class="col-md-6" style="color:crimson;" tabindex="0">
                  {{pmessage}}
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-3"></div>
                <div class="col-sm-6" style="white-space:nowrap">
                  <button id="btnClose" type="submit" class="btn btn-primary" tabindex="0" title="Clear"
                    aria-label="Close" (click)="ClearProjectInfo()">Clear</button>&nbsp;

                  <button id="btnSave" type="submit" class="btn btn-primary" tabindex="0" title="Save" aria-label="Save"
                    (click)="SaveProjectInfo()">Save Project</button>&nbsp;

                  <button id="btnNext" type="submit" class="btn btn-primary" tabindex="0" title="Next" aria-label="Next"
                    (click)="NextInfo()">Next</button>&nbsp;

                  <button id="btnClose" type="submit" class="btn btn-primary" tabindex="0" title="Close"
                    aria-label="Close" (click)="CloseProjectInfo()">Close</button>

                </div>
              </div>
              <br />
            </div>
          </form>
        </div>
      </form>
    </div>
  </div>
</div>






<div class="row" *ngIf="ISSHOW"
  style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
  <div class="td-col-md-2" style="width: 20%; padding-left: 20px;" class="mobileview"></div>
  <div class="card mobileviewmain" style="width: 60%; border-style: solid;border-color: #11263f;border-width: 2px; ">
    <div class="card-header">
      <div class="panel-heading" style="color:#ffffff;background-color: #11263f;" title="STAFF MAINTENANCE">
        <div class="page-titlehead">
          {{Action}} DOCUMENTS
        </div>
      </div>

    </div>



    <div class="card-body">
      <div tabindex="0">
        <p title="Fields marked with (*) are required."
          style="color:crimson; font-size:13px;font-style:italic;text-align:left">Fields
          marked
          with (*) are required.</p>
      </div>
      <form class="form-horizontal">
        <div>

          <div class="form-group row">
            <label tabindex="0" title="Project Number" aria-label="Project Number"
              class="col-md-3 form-control-label">Project #
            </label>
            <div class="col-md-6">
              <input type="text" name="Project Number" tabindex="0" [ngClass]="amountsdisable ? 'disable':''"
                [disabled]="IsReadOnly" title="Project Number" aria-label="Project Number" [(ngModel)]="docprojname"
                class="form-control">

            </div>
          </div>
          <div>


            <div class="form-group row">
              <label tabindex="0" title="Document Name" aria-label="Document Name"
                class="col-md-3 form-control-label">Document Name <span class="j-color">*</span></label>
              <div class="col-md-6">

                <input type="text" name="Document Name" tabindex="0" title="{{adocumentname}}"
                  aria-label="Document Name" [(ngModel)]="adocumentname" class="form-control" maxlength="50">


              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-3 form-control-label" tabindex="0" title="File Name" aria-label="File Name">File Name
                <span class="j-color">*</span></label>
              <div class="col-md-6">
                <input type="file" aria-label="File Name" id="file" #file [disabled]="DocumentID !== 0"
                  (change)="handleFileInput($event.target.files)">

              </div>
            </div>



            <div class="form-group row">
              <label class="col-md-3 form-control-label" tabindex="0" title="Public Accessible "
                aria-label="Public Access ">Public Access
              </label>
              <div class="col-md-6">
                <input type="checkbox" aria-label="Public Accessible" style="width:20px;height:20px;"
                  [(ngModel)]="ispublicAccessible" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-6" style="color:crimson;" tabindex="0">
                {{dmessage}}
                {{filemessage}}
              </div>

            </div>
          </div>
        </div>
        <div>
          <div class="form-group row">
            <div class="col-sm-3"></div>
            <div class="col-sm-6" style="white-space:nowrap">
              <button id="btnPreviousMD" type="submit" class="btn btn-primary btnprevious button_history" tabindex="0"
                title="Previous" aria-label="Previous" (click)="Previousdocs()">Previous</button>
              &nbsp;
              <button id="btnClearMD" type="submit" class="btn btn-primary btnclear button_history" tabindex="0"
                title="Clear" aria-label="Clear" (click)="acdclear()">Clear</button>
              &nbsp;
              <button id="btnSaveMD" type="submit" class="btn btn-primary btnsave button_history" tabindex="0"
                title="Save" aria-label="Save" (click)="SaveDocs()">Save</button>
              &nbsp;

              <button id="btnCloseMD" type="submit" class="btn btn-primary btndone button_history" tabindex="0"
                title="Close" aria-label="Close" (click)="CloseProjectInfo()">Close</button>
            </div>
          </div>
          <br />

        </div>
      </form>
    </div>

    <div *ngIf="cdocsvisible" class="mat-elevation-z8">
      <mat-table [dataSource]="DocsdataSource" matSort>
        <ng-container matColumnDef="DocumentName">
          <mat-header-cell *matHeaderCellDef tabindex=0 aria-label="Document Name">
            <label id="DocumentName" aria-label="Document Name">Document Name</label>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" tabindex="0" style="width: 100%;">
            <span class="mobile-label" style="min-width: 150px"><label aria-label="Document Name">Document
                Name:</label></span>
            <div title="{{element.DocumentName}} " class="displaynormal column-overflow">{{element.DocumentName}}</div>
            <div title="{{element.DocumentName}} " class="displaysmall" style="display: none;">{{element.DocumentName}}
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="FileName">
          <mat-header-cell *matHeaderCellDef tabindex=0 aria-label="File Name">
            <label id="FileName" aria-label="Street Name">File Name</label>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" tabindex="0" style="width: 100%;">
            <span class="mobile-label" style="min-width: 150px"><label aria-label="File Name">File Name:
              </label></span>
            <div class="displaynormal column-overflow" title="{{element.FileName}} ">{{element.FileName}}</div>
            <div class="displaysmall" style="display: none;" title="{{element.FileName}} ">{{element.FileName}}
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="DocumentAuthor">
          <mat-header-cell *matHeaderCellDef tabindex=0 aria-label="Document Author">
            <label id="DocumentAuthor" aria-label="Document Author">Document Author</label>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" tabindex="0" style="width: 100%;">
            <span class="mobile-label" style="min-width: 150px"><label aria-label="Document Author">Document Author:
              </label></span>
            <div class="displaynormal column-overflow" title="{{element.DocumentAuthor}} ">{{element.DocumentAuthor}}
            </div>
            <div class="displaysmall" style="display: none;" title="{{element.DocumentAuthor}} ">
              {{element.DocumentAuthor}}
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="PublicAccess">
          <mat-header-cell *matHeaderCellDef tabindex=0 aria-label="Public Access">
            <label id="PublicAccess" aria-label="Public Access">Public Access</label>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" tabindex="0" style="width: 100%;">
            <span class="mobile-label" style="min-width: 150px"><label aria-label="Public Access">Public Access:
              </label></span>
            <div class="displaynormal column-overflow" title="{{element.PublicAccess === true ? 'Yes' : 'No'}}">
              {{element.PublicAccess === true ? 'Yes' : 'No'}}</div>
            <div class="displaysmall" style="display: none;" title="{{element.PublicAccess === true ? 'Yes' : 'No'}}">
              {{element.PublicAccess === true ? 'Yes' : 'No'}}
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Update">
          <mat-header-cell *matHeaderCellDef> Update</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="mobile-label">Update:</span>
            <img style="cursor: pointer; color: #fff;" title="Update" tabindex="0"
              (click)="editprojectdocumentItem(element)" src="../assets/images/icon_edit.png">
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Delete">
          <mat-header-cell *matHeaderCellDef> Delete</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="mobile-label">Delete:</span>
            <img style="cursor: pointer; color: #fff;" title="Delete" tabindex="0" (click)="deleteprojectdocs(element);"
              src="../assets/images/delete_icon.png">
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
      <!-- <mat-paginator [pageSizeOptions]="[10,15,20]" [pageSize]="10" showFirstLastButtons></mat-paginator> -->

    </div>
  </div>
</div>
<br>
